export default "__VITE_ASSET__BHOeM$kL__"